import generalStrings from 'modules/general/strings';
import SectionDivider from 'modules/common/components/SectionDivider';

import { Wrapper, Icon, Title, SubTitle } from './RegisterConfirmation.style';

const RegisterConfirmation = () => (
  <Wrapper>
    <Icon />
    <SectionDivider gap={19} />
    <Title>{generalStrings.registerForm.formConfirmationTitle}</Title>
    <SectionDivider gap={8} />
    <SubTitle>{generalStrings.registerForm.formConfirmationSubTitle}</SubTitle>
  </Wrapper>
);

export default RegisterConfirmation;
